import React, { useState } from 'react';
import { authAPI } from '../services/api';
import useStore from '../store/useStore';
import '../styles/UserProfile.css';

const UserProfile = () => {
  const user = useStore((state) => state.user);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();

    // Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      setMessage('');
      return;
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters long');
      setMessage('');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      setMessage('');
      return;
    }

    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await authAPI.changePassword(currentPassword, newPassword);

      if (response.success) {
        setMessage('Password changed successfully!');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setError(response.error || 'Failed to change password');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="user-profile-container">
      <h1 className="page-title">User Profile</h1>

      <div className="profile-section">
        <h2 className="section-title">Account Information</h2>
        <div className="info-grid">
          <div className="info-item">
            <label>Username</label>
            <div className="info-value">{user?.username}</div>
          </div>
          <div className="info-item">
            <label>Email</label>
            <div className="info-value">{user?.email}</div>
          </div>
          <div className="info-item">
            <label>Full Name</label>
            <div className="info-value">{user?.fullName || 'Not set'}</div>
          </div>
          <div className="info-item">
            <label>Role</label>
            <div className="info-value role-badge role-{user?.role}">
              {user?.role === 'super_admin' ? 'Super Admin' :
               user?.role === 'admin' ? 'Admin' : 'User'}
            </div>
          </div>
        </div>
      </div>

      <div className="profile-section">
        <h2 className="section-title">Change Password</h2>
        <form onSubmit={handleChangePassword} className="password-form">
          {error && (
            <div className="message error-message">{error}</div>
          )}
          {message && (
            <div className="message success-message">{message}</div>
          )}

          <div className="form-group">
            <label htmlFor="currentPassword">Current Password</label>
            <input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              disabled={isLoading}
              autoComplete="current-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={isLoading}
              autoComplete="new-password"
            />
            <small className="form-hint">Minimum 6 characters</small>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm New Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={isLoading}
              autoComplete="new-password"
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={isLoading}
          >
            {isLoading ? 'Changing Password...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserProfile;
